var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComplianceData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33398 6.12728C3.33398 4.28561 6.31732 2.79395 10.0007 2.79395C13.684 2.79395 16.6673 4.28561 16.6673 6.12728C16.6673 7.96895 13.684 9.46061 10.0007 9.46061C6.31732 9.46061 3.33398 7.96895 3.33398 6.12728ZM3.33398 10.2939V7.79395C3.33398 9.63561 6.31732 11.1273 10.0007 11.1273C13.684 11.1273 16.6673 9.63561 16.6673 7.79395V10.2939C16.6673 12.1356 13.684 13.6273 10.0007 13.6273C6.31732 13.6273 3.33398 12.1356 3.33398 10.2939ZM3.33398 14.4606V11.9606C3.33398 13.8023 6.31732 15.2939 10.0007 15.2939C13.684 15.2939 16.6673 13.8023 16.6673 11.9606V14.4606C16.6673 16.3023 13.684 17.7939 10.0007 17.7939C6.31732 17.7939 3.33398 16.3023 3.33398 14.4606Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplianceData);
export default __webpack_public_path__ + "static/media/ComplianceData.b3317cbfcb8fb27c6348dc6a8dc8e9f7.svg";
export { ForwardRef as ReactComponent };